import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['link', 'tag'];

  connect() {
    this.toggle()
  }

  toggle() {
    if (event) event.preventDefault()

    var currentUrl
    if (event && event.currentTarget) {
      currentUrl = event.currentTarget.href
    } else {
      currentUrl = document.URL
    }

    var urlParts = currentUrl.split('#')
    var anchor = (urlParts.length > 1) ? urlParts[1] : undefined

    // Update tag targets
    let target = this.tagTargets.find(item => item.href.split('#')[1] == anchor)
    let selectedTarget = this.tagTargets.find(item => item.getAttribute('data-selected') == 'true')
    if (selectedTarget) selectedTarget.removeAttribute('data-selected')
    if (target != selectedTarget) {
      console.log('select')
      target.setAttribute('data-selected', true)
      window.location.hash = anchor
    } else {
      anchor = undefined
      window.location.hash = ''
    }

    // Update link targets
    this.linkTargets.forEach((item) => {
      if (anchor == undefined || item.dataset.tags.includes(anchor)) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })
  }
}
